module.exports = __webpack_public_path__ + "static/media/code-quiz.67f54cd5.png";